import { useState, useEffect, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Input, TextArea, Select, TextAreaAdvanced, InputImageUploadSimple } from "../../../Layout/Forms/Form";

const FormTablesGroup = ({show, handleModalhide, color, handlerSubmit}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        form: {
            color: color,
            price:''
        },
        errors: [],
    });
    const handleChangeInputs = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    [e.target.name]: e.target.value
                }
            });
        }
    }

    const handleSubmitForm = () => {
        handlerSubmit(state.form.price)
    }


    return (
        
        <>
            <Modal show={show} onHide={handleModalhide}>
                <Modal.Header closeButton>
                    <Modal.Title>Editar grupo de mesas</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    
                    <div className="row">
                        <div className='col-1'>
                            <div style={{borderRadius: '50px', backgroundColor: color, height: '25px', width: '25px', marginTop: '25px'}}>&nbsp;</div>
                        </div>
                        <div className="col-11">
                            <Input
                                label="Preço"
                                name="price"
                                value={state.form.price}
                                onChange={(e) => handleChangeInputs(e)}
                                type="text"
                                style={{textAlign: 'right'}}
                                errors={state.errors}
                            />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className="alert alert-warning" role="alert">
                                <i className='fa-solid fa-triangle-exclamation me-3'></i> Atenção ao alterar o valor, todas as mesas pertencentes a este grupo iram ser atualizados.
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalhide}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={() => handleSubmitForm()}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default FormTablesGroup;